export const CAR_LISTING_LOADER_TEXT = [
    "Not in love with your car? Return it within 7 days, no questions asked.",
    "We're picky so you don't have to be. Only 3 out of 10 cars pass our tough inspections.",
    "We believe in our cars. Not satisfied? Get a full refund.",
    "Each car is meticulously checked with a 300-point inspection to ensure it's top-notch for you."
];
